import { WageSchema } from '../wage-schema.model';
import { ActivityRole } from '../../activity/lib/activity.interfaces';

export function getWageSchemaWage(
  schema: WageSchema,
  role: ActivityRole,
  age: number,
): number {
  const schematic = schema.schema;
  const roleSeries = schematic[role];
  if (!roleSeries)
    throw new WageSchemaError(
      $localize`Missing activity '${role}' in wage schema '${schema.name}'`,
    );
  const entries = Object.entries(roleSeries);
  const [maxAge, wage] = entries.find(
    ([maxAge, wage]) => age < parseInt(maxAge) + 1,
  ) ?? [entries[entries.length - 1][0], -1];
  if (wage === -1)
    throw new WageSchemaError(
      $localize`Age ${age} out of range for max age ${maxAge} for activity '${role}' in wage schema '${schema.name}'`,
    );
  return wage;
}

export class WageSchemaError extends Error {}
